import { ApiError } from '../errors/api-error.js';

export class TenantDirectoryService {
    constructor(api, config = {}) {
        this.api = api;
        this.config = config;
    }

    async getConfig() {
        try {
            const body = await this.api.getConfig();
            return { success: body.success ?? true, data: body.data, message: body.message };
        } catch (error) {
            throw this._handleError(error, 'Dizin yapılandırması alınamadı');
        }
    }

    async upsertConfig(data) {
        try {
            const body = await this.api.upsertConfig(data);
            return { success: body.success ?? true, data: body.data, message: body.message };
        } catch (error) {
            throw this._handleError(error, 'Dizin yapılandırması kaydedilemedi');
        }
    }

    async listRoleMappings() {
        try {
            const body = await this.api.listRoleMappings();
            return { success: body.success ?? true, data: body.data || [], message: body.message };
        } catch (error) {
            throw this._handleError(error, 'Rol eşlemeleri alınamadı');
        }
    }

    async createRoleMapping(data) {
        try {
            const body = await this.api.createRoleMapping(data);
            return { success: body.success ?? true, data: body.data, message: body.message };
        } catch (error) {
            throw this._handleError(error, 'Eşleme oluşturulamadı');
        }
    }

    async deleteRoleMapping(id) {
        try {
            const body = await this.api.deleteRoleMapping(id);
            return { success: body.success ?? true, message: body.message };
        } catch (error) {
            throw this._handleError(error, 'Eşleme silinemedi');
        }
    }

    async syncNow() {
        try {
            const body = await this.api.syncNow();
            return { success: body.success ?? true, data: body.data, message: body.message };
        } catch (error) {
            throw this._handleError(error, 'Senkron başarısız');
        }
    }

    async listDirectoryFacets() {
        try {
            const body = await this.api.listDirectoryFacets();
            return { success: body.success ?? true, data: body.data, message: body.message };
        } catch (error) {
            throw this._handleError(error, 'Dizin değerleri alınamadı');
        }
    }

    async listDirectoryUsers(params = {}) {
        try {
            const body = await this.api.listDirectoryUsers(params);
            return { success: body.success ?? true, data: body.data || [], meta: body.meta, message: body.message };
        } catch (error) {
            throw this._handleError(error, 'Dizin kullanıcıları alınamadı');
        }
    }

    async importDirectoryUsers(data) {
        try {
            const body = await this.api.importDirectoryUsers(data);
            return { success: body.success ?? true, data: body.data, message: body.message };
        } catch (error) {
            throw this._handleError(error, 'İçe alma başarısız');
        }
    }

    _handleError(error, defaultMessage) {
        if (error instanceof ApiError) throw error;
        if (error.response) throw ApiError.fromResponse(error);
        throw new ApiError(error.message || defaultMessage, 500, 'UNKNOWN_ERROR', error);
    }
}
